// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"199":"156cf4eb","329":"8a57c887","635":"b20e56ef","686":"e5f5d72e","759":"f7b19324","764":"935d3430","840":"87d95877"}[chunkId] + ".chunk.js";
};